export enum FmsSubMenu {
    MasterProfit = "MasterProfit",
    MasterProfitHBL = "MasterProfitHBL",
    OICargoManifest = "OICargoManifest",
    OOCargoManifest = "OOCargoManifest",
    AICargoManifest = "AICargoManifest",
    AOCargoManifest = "AOCargoManifest",
    FolderLabel = "FolderLabel",
    OutOfStateLog = "OutOfStateLog",
    ArrivalNotice = "ArrivalNotice",
    _2ndArrivalNotice = "2ndArrivalNotice",
    WorkSheet = "WorkSheet",
    OIHouseBL = "OIHouseBL",
    HouseProfit = "HouseProfit",
    CarrierCertificate = "CarrierCertificate",
    ExdecTransit = "ExdecTransit",
    DockReceipt = "DockReceipt",
    MasterSet = "MasterSet",
    TelexReleaseMessage = "TelexReleaseMessage",
    OOHBook = "OOHBook",
    OEUSDA = "OEUSDA",
    AuthEntry = "AuthEntry",
    TsaSecurity = "TsaSecurity",
    TsaUnknown = "TsaUnknown",
    WReceipt = "WReceipt",
    WShip = "WShip",
    WLabelReceive = "WLabelReceive",
    WLabelShip = "WLabelShip",
    FArrivalNotice = "FArrivalNotice",
    Invoice = "Invoice",
    PuInvoice = "PuInvoice",
    PrintCheckSlip = "PrintCheckSlip",
    PrintMessengerSlip = "PrintMessengerSlip",
    STARCFSMANI = "STARCFSMANI",
    CPHistory = "CPHistory",
    BPHistory = "BPHistory",
    MPHistory = "MPHistory",
    APHistory = "APHistory",
    CompanyProfile = "CompanyProfile",
    SendEmail = "SendEmail",
    SendFax = "SendFax",
    IssueReady = "IssueReady",
    AesAir = "AesAir",
    AesOcean = "AesOcean",
    AesOtherOP = "AesOtherOP",
    AesEei = "AesEei",
    AesResponse = "AesResponse",
    AesSite = "AesSite",
    AesUsageReport = "AesUsageReport",
    AmsFiling = "AmsFiling",
    IsfFiling = "IsfFiling",
    Isf10Filing = "Isf10Filing",
    Isf5Filing = "Isf5Filing",
    IsfUpload = "IsfUpload",
    IsfDetail = "IsfDetail",
    Eawb = "Eawb",
    AciFiling = "AciFiling",

    // for billings menu
    CrDbNote = "CrDbNote",
    NewCustomerPay = "NewCustomerPay",
    NewBillPay = "NewBillPay",
    CustomerPayList = "CustomerPayList",
    BillPayList = "BillPayList",
    SwitchJournal = "SwitchJournal",
    OpenHistoryView = "OpenHistoryView",
    OpenDeleteHistoryView = "OpenAcctDeleteHistoryView",
    PrintBill = "PrintBill",
    BatchPrint = "BatchPrint",
    ViewPaymenHistory = "ViewPaymenHistory",
    AIAWB = "AIAWB",
    AutoBillingView = "ViewAutoBilling",
    CustomerStatement = "CustomerStatement",
    AgentStatement = "AgentStatement",
}

